import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

import { ConfigService } from '@services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    constructor(
        private activatedRoute: ActivatedRoute,
        private configService: ConfigService,
        @Inject(DOCUMENT) private document: Document,
        private router: Router
    ) {
        this.clearLegacyCookies();

        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                // Show loading indicator
                window.scrollTo(0, 0);
            }

            if (event instanceof NavigationEnd) {
                // Hide loading indicator
            }

            if (event instanceof NavigationError) {
                // Hide loading indicator

                if (event.url !== 'login') {
                    if (event.error?.status === 0) {
                        const returnUrl: string = this.activatedRoute.snapshot.queryParams.return_url;
                        if (event.url && !returnUrl) {
                            this.router.navigate(['/server-status'], { queryParams: { return_url: encodeURI(event.url) } });
                        } else {
                            this.router.navigate(['/server-status'], { queryParamsHandling: 'preserve' });
                        }
                    }
                }

            }
        });
    }

    private clearLegacyCookies() {
        const key = this.configService.userSessionKey;
        if (this.document.cookie.includes(key + '=')) {
            this.document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        }
    }
}
